<template>
  <div class="DemandList w">
    <div class="mytable">
      <h2>需求列表</h2>

      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="企业名称">
          <el-input v-model="formInline.enterpriseName" placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item label="最大预算">
          <el-input v-model.number="formInline.maxBudget" placeholder="最大预算(￥)"></el-input>
        </el-form-item>
        <el-form-item label="最小预算">
          <el-input v-model.number="formInline.minBudget" placeholder="最小预算(￥)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
          :data="tableData"
          border
          height="500"
          style="width: 100%">
        <el-table-column type="index" label="序号" :index="indexMethod" width="50"></el-table-column>
        <el-table-column
            v-for="(item,index) in tableConfig"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize"
                     layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: "DemandList",
  data() {
    return {
      pageNum: 1,
      total: 10,
      pageSize: 10,

      formInline: {
        enterpriseName: '',
        maxBudget: '',
        minBudget: ''
      },

      //表格字段配置
      tableConfig: [
        {
          prop: "enterpriseName",
          label: "企业名称",
          width: "150",
        },

        {
          prop: "demandTitle",
          label: "需求标题",
          width: "150",
        },

        {
          prop: "demandDescribe",
          label: "需求描述",
        },

        {
          prop: "minBudget",
          label: "最小预算(￥)",
          width: "120",
        },

        {
          prop: "maxBudget",
          label: "最大预算(￥)",
          width: "120",
        },

        {
          prop: "address",
          label: "地址",
        },

        {
          prop: "contactName",
          label: "联系人",
          width: "100",
        },

        {
          prop: "phoneNumber",
          label: "联系电话",
        },

        {
          prop: "checkTime",
          label: "时间",
        },
      ],

      //表格数据
      tableData: []
    }
  },
  created() {
    this.getList()
    this.$store.dispatch('setActive', '/TradingHall')
  },
  mounted() {

  },
  beforeDestroy() {

  },

  methods: {
    onSubmit() {
      this.getList()
    },

    //获取数据
    async getList() {
      let data = {
        "enterpriseName": "",
        "maxBudget": "",
        "minBudget": "",
        "pageNum": this.pageNum,
        "pageSize": this.pageSize
      }

      Object.assign(data, JSON.parse(JSON.stringify(this.formInline)))

      try {
        let res = await this.$http.post(this.$const.RemoteSensingMall.CommodityDemandList, data)
        if (res.code === 200) {
          this.total = res.data.total
          this.tableData = res.data.list
          console.log(res);
        }
      } catch (e) {
        console.log(e);
      }


    },

    handleCurrentChange(pageNum) {
      console.log(`当前页: ${pageNum}`);
      this.pageNum = pageNum
      this.getList()
    },
    // 表格序号
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    }
  }
}
</script>

<style scoped lang="scss">
.DemandList {
  h2 {
    padding: 10px 0;
  }

  .mytable {
    margin-top: 10px;
  }

  .block {
    text-align: end;
    margin-top: 35px;
  }
}
</style>
